export const LEGAL_AUTHORIZATION = "LEGAL_AUTHORIZATION";
export const LEGAL_AUTHORIZATION_SUCCESS = "LEGAL_AUTHORIZATION_SUCCESS";
export const LEGAL_AUTHORIZATION_ERROR = "LEGAL_AUTHORIZATION_ERROR";
